'use client'

import { usePathname } from 'next/navigation'
import { type LanguageConfig, siteConfig } from './site-config'
import { getCurrentLanguage } from '@/lib/languages'

export function useCurrentLanguage(): LanguageConfig {
    const pathname = usePathname() || '/'
    return getCurrentLanguage(pathname)
}

export function useLanguageConfig() {
    const currentLanguage = useCurrentLanguage()
    
    return {
        currentLanguage,
        metadata: currentLanguage.metadata,
        contactInfo: currentLanguage.contactInfo,
        currency: currentLanguage.currency,
        features: siteConfig.features,
        general: siteConfig.general,
        getHomePath: () => currentLanguage.path || '/',
        isFeatureEnabled: (feature: keyof typeof siteConfig.features) => {
            return siteConfig.features[feature].enabled
        }
    }
}
